import { attachmentApi } from '@core/api';

// Resolve at click time: presigned URLs expire and must never be persisted in a view.
export async function downloadAttachment(id: string, fileName: string): Promise<void> {
  const response = await attachmentApi.GetDownloadUrl(id, { params: { inline: false } });
  const url = response.download_url?.url;
  if (!url) throw new Error('No download URL returned');
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
